export default __webpack_public_path__ + "static/media/manage.f6ca19ad.svg";